import { render, staticRenderFns } from "./AdminComments.vue?vue&type=template&id=2592965a&scoped=true&"
import script from "./AdminComments.vue?vue&type=script&lang=js&"
export * from "./AdminComments.vue?vue&type=script&lang=js&"
import style0 from "./AdminComments.vue?vue&type=style&index=0&id=2592965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592965a",
  null
  
)

export default component.exports